<template>
  <div v-if="evento">
    <v-list class="mt-5">
      <v-list-item-group v-if="evento" color="primary">
        <b>Fechas</b>
        <v-list-item-content v-for="f in evento.fechas">
          <v-list-item-title>{{ df(f.fecha_limite) }}
            <span v-if="f.hours != '00' && f.minute != '00' ">
            {{ f.hours }}:{{ f.minute }}
            </span>

          </v-list-item-title>
          <v-list-item-subtitle>{{ f.text }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item-group>
    </v-list>

    <v-list v-if="evento.dirreccions && evento.dirreccions > 0">
      <v-list-item-group  color="primary">
        <b>{{$t('Dirrecciones')}}</b>
        <v-list-item-content v-for="e in evento.dirreccions">
          <v-list-item-title>
            {{ e.dirreccion }}
            {{ e.cuidad }}
            {{ e.cp }}
            {{ e.pais }}
          </v-list-item-title>
          <v-list-item-subtitle>{{ e.texto }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item-group>
    </v-list>


    <v-list v-if="evento.web">
      <v-list-item-group  color="primary">
        <b>{{$t('Web')}}</b>
        <v-list-item-content >
          <v-list-item-title>
            <a :href="evento.web">{{evento.web}}</a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item-group>
    </v-list>

    <v-list v-if="evento.email">
      <v-list-item-group  color="primary">
        <b>{{$t('Email')}}</b>
        <v-list-item-content >
          <v-list-item-title>
            <a :href="'mailto:'+evento.email">{{evento.email}}</a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item-group>
    </v-list>

    <div v-if="$i18n.locale=='es'"  >
        <div v-if="evento.id > 43" v-html="evento.descripcion_es"></div>
        <nl2br v-else tag="p" :text="evento.descripcion_es" class-name="txt" />
    </div>
    <div v-if="$i18n.locale=='ca'"  >
        <div v-if="evento.id > 43" v-html="evento.descripcion_ca"></div>
        <nl2br v-else tag="p" :text="evento.descripcion_ca" class-name="txt" />

    </div>
  </div>
</template>

<script>
export default {
  name: "EventText",
  props: {
    evento: Object
  },
  data() {
    return {
      event: this.evento,
      isHtmlca: true,
      isHtmles: true,
    };
  },
  methods: {
    df(d) {
      let current_datetime = new Date(d)
      return current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate()
    }
  },
  watch: {
    'evento.descripcion_es'(newVal) {
      //if (/<\/?[a-z][\s\S]*>/i.test(newVal)) this.isHtmles = true
    },
    'this.evento.descripcion_ca'(newVal) {
      //if (/<\/?[a-z][\s\S]*>/i.test(newVal)) this.isHtmles = true
    }
  }
}
</script>